import { LandingPageTypes } from '../../helpers/domain/landingPages';
import { PropertyType } from '../../helpers/domain/propertyTypes';
import { PostSubcategory } from '../domain/postCategories';

export const DFPConfig = {
  dfpNetworkId: '133034368',
  gtmId: 'GTM-MVJJRWF',
};

export const DFP_PRICE_RANGE = {
  convertedPriceRangeDFP: [
    '0_100k',
    '100k_200k',
    '200k_300k',
    '300k_400k',
    '400k_500k',
    '500k_600k',
    '600k_700k',
    '700k_800k',
    '800k_900k',
    '900k_1m',
    '1m_2m',
    '2m_3m',
    '3m_4m',
    '4m_5m',
    '5m_6m',
    '6m_7m',
    '7m_8m',
    '8m_9m',
    '9m_10m',
    '10m_15m',
    '15m_20m',
    '20m_25m',
    '25m_30m',
    '30m_35m',
    '35m_40m',
    '40m_45m',
    '45m_50m',
    '50m_100m',
  ],
  maxPriceForEachRange: [
    100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 900000,
    1000000, 2000000, 3000000, 4000000, 5000000, 6000000, 7000000, 8000000,
    9000000, 10000000, 15000000, 20000000, 25000000, 30000000, 35000000,
    40000000, 45000000, 50000000, 100000000,
  ],
};

export const adSubsectByPropertyType = new Map<PropertyType, string>([
  [PropertyType.Condominium, 'condo'],
  [PropertyType.House, 'house'],
  [PropertyType.Townhome, 'townhouse'],
  [PropertyType.HolidayHomes, 'holidayhomes'],
  [PropertyType.HomeOffice, 'homeoffice'],
  [PropertyType.MixedUse, 'mixeduse'],
  [PropertyType.Commercial, 'commercial'],
]);

export const adSubsectByPostCategory = new Map<PostSubcategory, string>([
  [PostSubcategory.PropertyNews, 'property'],
  [PostSubcategory.GeneralNews, 'general'],
  [PostSubcategory.BuyAndSell, 'buysell'],
  [PostSubcategory.Finance, 'finance'],
  [PostSubcategory.Investment, 'investment'],
  [PostSubcategory.InteriorInspiration, 'inspiration'],
  [PostSubcategory.Renovation, 'renovation'],
  [PostSubcategory.Maintenance, 'maintainence'],
]);

export const adSectByPageType = new Map([
  [LandingPageTypes.HomePage, 'homepage'],
  [LandingPageTypes.CondoPage, 'condo'],
  [LandingPageTypes.HousePage, 'house'],
  [LandingPageTypes.TownhomePage, 'townhouse'],
  [LandingPageTypes.VacationPage, 'holidayhomes'],
  [LandingPageTypes.HomeOfficePage, 'homeoffice'],
  [LandingPageTypes.MixedUsePage, 'mixeduse'],
  [LandingPageTypes.CommercialBuildingPage, 'commercial'],
  [LandingPageTypes.ReviewPage, 'review'],
  [LandingPageTypes.PreviewPage, 'preview'],
  [LandingPageTypes.PointOfViewPage, 'pov'],
  [LandingPageTypes.ProjectResearchPage, 'projectresearch'],
  [LandingPageTypes.LocationInsightPage, 'locationinsight'],
  [LandingPageTypes.NewsPage, 'news'],
  [LandingPageTypes.GuidesPage, 'guides'],
  [LandingPageTypes.DecorsPage, 'decors'],
  [LandingPageTypes.ArticlePage, 'articlepage'],
  [LandingPageTypes.ProjectPage, 'projectpage'],
  [LandingPageTypes.SearchResultPage, 'srchresult'],
  [LandingPageTypes.TrainlinesPage, 'trainline'],
  [LandingPageTypes.ZonesPage, 'zone'],
  [LandingPageTypes.PreviewCondoPage, 'preview'],
  [LandingPageTypes.PreviewHousePage, 'preview'],
  [LandingPageTypes.PreviewTownhomePage, 'preview'],
  [LandingPageTypes.ReviewCondoPage, 'review'],
  [LandingPageTypes.ReviewHousePage, 'review'],
  [LandingPageTypes.ReviewTownhomePage, 'review'],
]);

export enum AdUnits {
  HP_Billboard1 = 'thinkofliving_th/homepage/billboard1',
  HP_Billboard2 = 'thinkofliving_th/homepage/billboard2',
  HP_Billboard3 = 'thinkofliving_th/homepage/billboard3',
  HP_Billboard4 = 'thinkofliving_th/homepage/billboard4',
  HP_Billboard5 = 'thinkofliving_th/homepage/billboard5',
  HP_Pos1 = 'thinkofliving_th/homepage/pos1',
  HP_Pos2 = 'thinkofliving_th/homepage/pos2',
  HP_Pos3 = 'thinkofliving_th/homepage/pos3',
  HP_MrecInfiniteAd = 'thinkofliving_th/homepage/medrec_infinite_ad',
  AP_Billboard1 = 'thinkofliving_th/articlepage/billboard1',
  AP_MrecInfiniteAd = 'thinkofliving_th/articlepage/medrec_infinite_ad',
  AP_Medrec = 'thinkofliving_th/articlepage/medrec',
  PP_HalfPageAd = 'thinkofliving_th/projectpage/halfpage',
  PP_Billboard1 = 'thinkofliving_th/projectpage/billboard1',
  SRP_MrecInfiniteAd = 'thinkofliving_th/srchresult/medrec_infinite_ad',
}
